module.exports = __webpack_public_path__ + "img/背景色1.cccf7d01.png";